import { useContext } from 'react';
import Flex from './layouts/Flex';
import Box from './layouts/Box';
import MessagebarContext, {
  getAnimationDuration,
} from '../../context/MessagebarContext';
import { keyframes } from '@emotion/react';
import CloseIcon from 'imagesUwKluis/svg/close.svg';

const animation = keyframes({
  '0%': { opacity: '0' },
  '30%': { opacity: '1' },
  '90%': { opacity: '1' },
  '100%': { opacity: '0' },
});

const Messagebar = () => {
  const {
    message: { text, color, status },
    clearMessage,
  } = useContext(MessagebarContext);

  const animationDuration = getAnimationDuration(text);

  return status && (
    <Flex
      width="100%"
      height="48px"
      justifyContent="center"
      alignItems="center"
      position="fixed"
      top="0"
      let="0"
      color={color}
      css={(theme) => ({
        animationName: animation,
        animationDuration: `${animationDuration}ms`,
        zIndex: '102',
        background: 'white',
        '::after': {
          content: "''",
          width: '100%',
          height: '100%',
          backgroundColor: theme.colors[color],
          opacity: 0.2,
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: -1,
        },
      })}
    >
      <Flex alignItems="center" flex="100%">
        <Box textAlign="center" flexGrow="1" mr="-48px">
          {text}
        </Box>
        <CloseIcon
          height="2rem"
          width="2rem"
          css={({ colors }) => ({
            fill: colors[color],
            cursor: 'pointer',
            marginRight: '16px',
          })}
          onClick={clearMessage}
        />
      </Flex>
    </Flex>
  );
};
export default Messagebar;
